import React from "react";
import {
  AuthContainer,
  AuthSideInfo,
  AuthSideForm,
  InfoContainer,
  ICTITLE,
} from "./auth.styled";
import LoginForm from "components/auth/LoginForm";
import { Modal } from "@mui/material";
import { useSelector } from "react-redux";
import ForgotPasswordModal from "components/userProfile/ForgotPasswordModal";
import { useTranslation } from "react-i18next";

export default function AuthLogin() {
  const { t } = useTranslation("auth");

  const {
    userType,
    isRegisterSuccessUser,
    isRegisterSuccessChurch,
    viewForgotPasswordModal,
  } = useSelector((state) => state.auth);

  return (
    <AuthContainer>
      <AuthSideInfo>
        <InfoContainer>
          <ICTITLE>{t("portal.aboutTitle")}</ICTITLE>
          <span>{t("portal.aboutBody")}</span>
        </InfoContainer>
      </AuthSideInfo>
      <AuthSideForm>
        <LoginForm />
      </AuthSideForm>
      <Modal open={viewForgotPasswordModal}>
        <ForgotPasswordModal />
      </Modal>
    </AuthContainer>
  );
}
